import React from 'react';

import { NexdosSecondaryColorEnum } from '../enums/NexdosSecondaryColorEnum';

interface StatisticCardProps {
  label: React.ReactNode;
  value: React.ReactNode;
  backgroundColor?: NexdosSecondaryColorEnum;
}

export default function StatisticCard(props: StatisticCardProps) {
  const defaultBackgroundColor = NexdosSecondaryColorEnum.TEAL_PPT_3;

  return (
    <div
      className={'rounded-2xl overflow-hidden relative'}
      style={{
        borderColor: props.backgroundColor ?? defaultBackgroundColor,
        color: props.backgroundColor ?? defaultBackgroundColor
      }}
    >
      <div
        className={'absolute top-0 left-0 w-full h-full opacity-20'}
        style={{
          backgroundColor: props.backgroundColor ?? defaultBackgroundColor
        }}
      />
      <div className={'flex flex-col gap-1 items-center justify-center relative py-6 w-full h-full'}>
        <div className={'font-bold uppercase'}>{props.label}</div>
        <h3 className={'text-4xl font-bold'}>{props.value}</h3>
      </div>
    </div>
  );
}
